import { ref } from 'vue';
import { useEventListener } from "@/mixins/useEventListener";

export const useMedia = (query) => {
  const mediaQuery = window.matchMedia(query);
  const matches = ref(mediaQuery.matches);
  useEventListener(mediaQuery, 'change', (e) => {
    matches.value = e.matches;
  });
  return matches;
}